(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fs-hero')) {
    class FsHero extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.fs-hero__track');
        this.slides = [...this.querySelectorAll('.fs-hero__slide')];
        this.dots = [...this.querySelectorAll('.fs-hero__dot')];
        this.index = 0;
        if (this.slides.length < 2) return;

        this.onDot = (e) => {
          const btn = e.target.closest('[data-go]');
          if (btn) this.go(Number(btn.dataset.go), true);
        };
        this.addEventListener('click', this.onDot);

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) this.setActive(Number(entry.target.dataset.index));
            });
          },
          { root: this.track, threshold: [0.6] }
        );
        this.slides.forEach((s) => this.observer.observe(s));

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduced && !window.Shopify?.designMode) {
          this.speed = Number(this.dataset.speed) || 6000;
          this.start();
          this.addEventListener('pointerenter', () => this.stop());
          this.addEventListener('pointerleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
        }
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
        this.removeEventListener('click', this.onDot);
      }

      setActive(i) {
        this.index = i;
        this.dots.forEach((d, n) => d.setAttribute('aria-selected', n === i ? 'true' : 'false'));
      }

      go(i, user = false) {
        const n = (i + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.slides[n].offsetLeft, behavior: 'smooth' });
        this.setActive(n);
        if (user) this.stop();
      }

      start() {
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }

      stop() {
        clearInterval(this.timer);
      }
    }
    customElements.define('fs-hero', FsHero);

    document.addEventListener('shopify:block:select', (e) => {
      const slide = e.target.closest?.('.fs-hero__slide');
      const hero = slide?.closest('fs-hero');
      if (hero && hero.go) hero.go(Number(slide.dataset.index), true);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
